import { useEffect } from "react";
import { Outlet, useLocation, useMatch, useParams } from "react-router";

import { useQueryParams } from "common/utilities";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { getUserId } from "domains/authentication/selectors";
import { resetCreateMap } from "domains/createMapDetail/actions";
import { getSiteLanguage } from "domains/language/selectors";
import { initTopicDetail } from "domains/topicDetail/actions";
import { setTransformationMapEditMode, setTransformationMapTopic } from "domains/transformationMap/actions";
import { getTmEditMode } from "domains/transformationMap/selectors";

export const TopicDetailOutlet = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const createMatch = useMatch("/create/new");
  const { topicId } = useParams();
  const { editing } = useQueryParams();
  const siteLanguage = useSelector(getSiteLanguage);
  const isEditing = useSelector(getTmEditMode);
  const userId = useSelector(getUserId);

  const isNew = createMatch !== null;

  useEffect(() => {
    if (topicId && !isNew) dispatch(initTopicDetail({ id: topicId, editMode: !!editing, pathname }));
  }, [dispatch, editing, isNew, pathname, topicId, siteLanguage, userId]);

  useEffect(
    () => () => {
      dispatch(resetCreateMap());
      dispatch(setTransformationMapTopic());
    },
    [dispatch],
  );

  useEffect(() => {
    if (!!editing !== isEditing || !topicId || isNew)
      dispatch(setTransformationMapEditMode({ mode: !!editing || !topicId || isNew }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);

  return <Outlet />;
};
